module.exports = __webpack_public_path__ + "assets/img/cat-white.fd8225b7.jpg";